module.exports = __webpack_public_path__ + "03_short_grey.93c46e34.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_short_grey.png
// module id = S0Lu
// module chunks = 0